export default __webpack_public_path__ + "static/media/codecentric_logo.573ade0c.png";